<template>
  <div class="container">
    <img src="@img/logo.png" class="kpfs-logo" />
    <img src="@img/game-title.png" class="title" />
    <div class="nav-wrapper">
      <img
        v-for="(item, index) of nav"
        :key="`nav-${index}`"
        :src="item"
        class="nav"
        v-show="index === onNavIndex"
      />
      <div
        class="navTap"
        v-for="(item, index) of nav"
        :key="`nav-tap-${index}`"
        :style="{ width: `${px2rem(navPos.w[index])}rem`, left: `${px2rem(navPos.l[index])}rem` }"
        @click="navTapHandler(index)"
      ></div>
    </div>

    <div
      v-for="(item, index) of exhibition"
      :key="index"
      :class="`exhibition exhibition-${index + 1}`"
      v-show="index === onNavIndex"
    >
      <div
        class="btn tap"
        v-for="(ex, exIndex) in item"
        :key="exIndex"
        :style="{
          width: `${px2rem(ex.pos[0])}rem`,
          height: `${px2rem(ex.pos[1])}rem`,
          left: `${px2rem(ex.pos[2])}rem`,
          top: `${px2rem(ex.pos[3])}rem`
        }"
        @click="exhibitionTap(ex.id)"
      ></div>
    </div>

    <div class="visited">
      <span>{{ visitedEx.length }}</span>
    </div>

    <transition
      mode="out-in"
      enter-active-class="fadeIn animated faster"
      leave-active-class="fadeOut animated faster"
    >
      <router-view></router-view>
    </transition>

    <transition
      mode="out-in"
      enter-active-class="fadeIn animated faster"
      leave-active-class="fadeOut animated faster"
    >
      <redPacket v-if="isCj"></redPacket>
    </transition>
  </div>
</template>

<script>
import hotcss from 'hotcss';

import redPacket from '@views/redPacket';
import nav1 from '@img/nav-1.png';
import nav2 from '@img/nav-2.png';
import nav3 from '@img/nav-3.png';
import nav4 from '@img/nav-4.png';

const exhibitionIdMap = [];

export default {
  name: 'game',
  components: { redPacket },
  data() {
    return {
      linkList: [],
      onNavIndex: 0,
      nav: [nav1, nav2, nav3, nav4],
      navPos: {
        w: [145, 160, 160, 160],
        l: [16, 161, 321, 482],
      },
      visited: [],
      visitedEx: [],
      exhibition: [
        // pos:[w,h,l,t]
        [
          { id: 1, pos: [280, 280, 189, 34] },
          { id: 1, pos: [200, 60, 461, 312] },
          { id: 2, pos: [188, 188, 24, 336] },
          { id: 2, pos: [235, 48, 146, 573] },
          { id: 3, pos: [216, 216, 429, 446] },
          { id: 3, pos: [720, 45, 323, 720] },
        ],
        [
          { id: 4, pos: [188, 37, 30, 15] },
          { id: 4, pos: [183, 183, 53, 84] },
          { id: 5, pos: [167, 167, 310, 25] },
          { id: 5, pos: [205, 43, 495, 11] },
          { id: 6, pos: [185, 38, 7, 420] },
          { id: 6, pos: [205, 205, 219, 285] },
          { id: 7, pos: [195, 195, 477, 210] },
          { id: 7, pos: [209, 41, 491, 448] },
          { id: 8, pos: [165, 165, 67, 510] },
          { id: 8, pos: [206, 42, 176, 718] },
          { id: 9, pos: [194, 194, 418, 559] },
          { id: 9, pos: [241, 49, 397, 804] },
        ],
        [{ id: 10, pos: [492, 634, 0, 0] }],
        [{ id: 11, pos: [700, 637, 0, 0] }],
      ],

      haveLottery: false,
      isCj: false,
    };
  },
  methods: {
    // eslint-disable-next-line no-undef
    px2rem: hotcss.px2rem,
    navTapHandler(index) {
      this.onNavIndex = index;
    },
    exhibitionTap(id) {
      console.log(id);
      this.$router.push({
        name: 'detail',
        params: { id, link: this.linkList.find((e) => e.id === id).address },
      });
    },
    checkCanLottery() {
      // let res = true;
      // this.exhibition.forEach((exs) => {
      //   let result = false;
      //   exs
      //     .map((ex) => ex.id)
      //     .forEach((id) => {
      //       if (this.visited.includes(id)) result = true;
      //     });
      //   if (!result) res = false;
      // });
      // return res;
      return this.visitedEx.length >= this.exhibition.length;
    },
    recordEx(id) {
      if (!this.visited.includes(id)) {
        this.visited.push(id);
        exhibitionIdMap.forEach((exsId, index) => {
          if (exsId.includes(id) && !this.visitedEx.includes(index)) {
            this.visitedEx.push(index);
          }
        });
        setTimeout(() => {
          this.$router.push({
            name: 'tick',
            params: { num: this.exhibition.length - this.visitedEx.length },
          });
        }, 300);
      }
    },
    callLottery() {
      console.log(this.checkCanLottery());
      if (!this.haveLottery && this.checkCanLottery()) this.isCj = true;
    },
    getList() {
      if (this.$loading.status) return;
      this.$loading.show('正在加载');
      this.$axios
        .get(this.$store.api.list)
        .then((res) => {
          this.linkList.push(...res.data);
        })
        .catch((err) => console.log(err))
        .finally(() => {
          this.$loading.hide();
        });
    },
    tickFail() {
      window.setTimeout(() => {
        this.$router.push('/tickFail');
      }, 300);
    },
  },
  created() {
    this.getList();
    exhibitionIdMap.push(...this.exhibition.map((exs) => exs.map((ex) => ex.id)));
  },
};
</script>

<style lang="scss" scoped>
.title {
  position: absolute;
  @include w(705);
  @include t(38);
  right: -0.4rem;
}

.nav-wrapper {
  @include w(658);
  @include center(658);
  position: absolute;
  @include t(168);
  .navTap {
    position: absolute;
    @include h(46);
    @include t(17);
  }
}

.exhibition {
  position: absolute;
  > .tap {
    position: absolute;
  }
}
.exhibition-1 {
  @include w(681);
  @include h(798);
  @include bg("exhibition-1.png");
  @include l(51);
  @include t(262);
}
.exhibition-2 {
  @include w(724);
  @include h(881);
  @include bg("exhibition-2.png");
  @include l(23);
  @include t(275);
}
.exhibition-3 {
  @include w(492);
  @include h(634);
  @include bg("exhibition-3.png");
  @include l(126);
  @include t(317);
}
.exhibition-4 {
  @include w(700);
  @include h(637);
  @include bg("exhibition-4.png");
  @include l(22);
  @include t(317);
}

.visited {
  @include w(328);
  @include h(115);
  position: absolute;
  @include bg("visited.png");
  @include l(26);
  bottom: 2rem;
  > span {
    position: absolute;
    font-size: 0.65rem;
    left: 3.1rem;
    top: 0.9rem;
    color: #0f1158;
    letter-spacing: -0.1rem;
    width: 0.7rem;
    text-align: center;
    line-height: 1em;
  }
}
</style>
